<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    香梅北站<br>
站点介绍<br>
香梅北站位于香梅路与侨香路交叉路口的西北侧，斜穿侨香路布置，呈东西走向。车站紧邻景田沃尔玛大型超市，香蜜湖一号等高档住宅区，北侧有福田区外国语学校。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:22	00:02	2号线	2分35秒	5分45秒<br>
莲塘	06:00	23:38	2号线	2分35秒	5分45秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:27	00:01	2号线	4分钟	5分钟<br>
莲塘	06:00	23:38	2号线	4分钟	5分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:27	00:51	2号线	4分钟	5分钟<br>
莲塘	06:00	00:38	2号线	4分钟	5分钟<br><br>
<br>
站点出口信息<br><br>
B1出入口:<br>
侨香路东侧<br><br>
B2出入口:<br>
侨香路南侧、香蜜湖一号、香蜜湖体育中心、香蜜丽格医疗美容、1979文化创意园<br><br>
B3出入口:<br>
香梅路、景田北街、福田区外国语学校、天然居、天明居、青海大厦<br><br>
D出入口:<br>
侨香路、特发小区、景田沃尔玛<br><br>
公交换乘信息<br><br>
D出入口:<br>
公交站名： 景田沃尔玛<br>
高快巴士25、73、104、316、323、B689 、M312、高快巴士28B3出入口<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "erhaoxian",
          title: "2号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>